
(function(){
  function initializePhotoPreview(){
  "use strict";
  var scene=document.getElementById("scene");
  var stage=document.getElementById("stage");
  var photoInput=document.getElementById("neonOwnPhotoFile");
  var photoBtn=document.querySelector('.bgbtn[data-bg="custom"]');
  var zoomInput=document.getElementById("neonOwnPhotoZoom");
  var rotationInput=document.getElementById("neonOwnPhotoRotation");
  var resetBtn=document.getElementById("neonOwnPhotoReset");
  var saveBtn=document.getElementById("neonOwnPhotoSave");
  var status=document.getElementById("neonOwnPhotoStatus");
  var badge=scene&&scene.querySelector(".fitbadge");
  if(!scene||!stage||!photoInput||!photoBtn||!zoomInput||!rotationInput||!resetBtn||!saveBtn)return;
  var photo=null,photoUrl=null;
  var position={x:0,y:0,zoom:1,rotation:0};
  var pointers=new Map(), startDistance=0,startZoom=1;
  function active(){return scene.classList.contains("custom");}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
  var statusTimer=null;
  function message(str){
    status.textContent=str;
    var important=/(nicht|bitte|gross|groß|fehl|unterstützt|gespeichert|erstellt|möglich)/i.test(str);
    status.classList.toggle("is-visible",important);
    if(statusTimer)clearTimeout(statusTimer);
    if(important)statusTimer=setTimeout(function(){status.classList.remove("is-visible");},5000);
  }
  function applyPosition(){
    scene.style.setProperty("--neon-photo-x",position.x+"px");
    scene.style.setProperty("--neon-photo-y",position.y+"px");
    scene.style.setProperty("--neon-photo-zoom",String(position.zoom));
    scene.style.setProperty("--neon-photo-rotate",position.rotation+"deg");
    zoomInput.value=String(Math.round(position.zoom*100));
    rotationInput.value=String(position.rotation);
  }
  function reset(){
    position={x:0,y:0,zoom:1,rotation:0};
    applyPosition();
    message("Mit Finger oder Maus verschieben. Foto bleibt lokal.");
  }
  function updateBadge(){
    if(!active())return;
    scene.classList.toggle("has-ownphoto",!!photo);
    var label="EIGENES FOTO · VORSCHAU OHNE MASSSTAB";
    if(badge&&badge.textContent!==label)badge.textContent=label;
  }
  function setPhoto(image,url){
    if(photoUrl)URL.revokeObjectURL(photoUrl);
    photoUrl=url;photo=image;
    scene.style.setProperty("--neon-custom-image",'url("'+url+'")');
    scene.classList.add("has-ownphoto");
    reset();
    message("Foto bleibt lokal. Platzierung ändert den Preis nicht.");
  }
  photoBtn.addEventListener("click",function(){updateBadge();});
  photoInput.addEventListener("change",function(){
    var file=photoInput.files&&photoInput.files[0];
    if(!file)return;
    if(file.size>20*1024*1024){message("Foto ist zu gross (max. 20 MB).");photoInput.value="";return;}
    var allowed=/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)||/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type);
    if(!allowed){message("Bitte JPG, PNG, WEBP oder unterstütztes HEIC verwenden.");photoInput.value="";return;}
    var newUrl=URL.createObjectURL(file);
    var img=new Image();
    img.onload=function(){
      if(!img.naturalWidth||!img.naturalHeight){URL.revokeObjectURL(newUrl);message("Bild konnte nicht geladen werden.");return;}
      setPhoto(img,newUrl);
      if(!active())photoBtn.click();
      updateBadge();
    };
    img.onerror=function(){URL.revokeObjectURL(newUrl);message("Dieses Bildformat wird vom Browser nicht unterstützt. Bitte JPG oder PNG verwenden.");};
    img.src=newUrl;
    photoInput.value="";
  });
  zoomInput.addEventListener("input",function(){position.zoom=clamp(Number(this.value)/100,.4,1.8);applyPosition();});
  rotationInput.addEventListener("input",function(){position.rotation=clamp(Number(this.value),-25,25);applyPosition();});
  resetBtn.addEventListener("click",reset);
  function coords(ev){return {x:ev.clientX,y:ev.clientY};}
  function distance(p){var a=Array.from(p.values());return Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y);}
  stage.setAttribute("tabindex","0");
  stage.setAttribute("aria-label","Neon-Vorschau. Im eigenen Foto mit Pfeiltasten verschieben.");
  stage.addEventListener("pointerdown",function(ev){
    if(!active()||!photo||ev.button>0)return;
    pointers.set(ev.pointerId,coords(ev));
    try{stage.setPointerCapture(ev.pointerId);}catch(e){}
    if(pointers.size===2){startDistance=distance(pointers);startZoom=position.zoom;}
    stage.classList.add("is-dragging");
    ev.preventDefault();
  });
  stage.addEventListener("pointermove",function(ev){
    if(!active()||!photo||!pointers.has(ev.pointerId))return;
    var prev=pointers.get(ev.pointerId),next=coords(ev);pointers.set(ev.pointerId,next);
    if(pointers.size===2 && startDistance>0){
      position.zoom=clamp(startZoom*distance(pointers)/startDistance,.4,1.8);
    }else if(pointers.size===1){
      position.x=clamp(position.x+next.x-prev.x,-scene.clientWidth*.55,scene.clientWidth*.55);
      position.y=clamp(position.y+next.y-prev.y,-scene.clientHeight*.55,scene.clientHeight*.55);
    }
    applyPosition();
    ev.preventDefault();
  });
  function endPointer(ev){
    pointers.delete(ev.pointerId);
    if(pointers.size<2){startDistance=0;startZoom=position.zoom;}
    if(!pointers.size)stage.classList.remove("is-dragging");
  }
  stage.addEventListener("pointerup",endPointer);
  stage.addEventListener("pointercancel",endPointer);
  stage.addEventListener("lostpointercapture",endPointer);
  stage.addEventListener("keydown",function(ev){
    if(!active()||!photo)return;
    var amount=ev.shiftKey?12:3;
    if(ev.key==="ArrowLeft")position.x-=amount;
    else if(ev.key==="ArrowRight")position.x+=amount;
    else if(ev.key==="ArrowUp")position.y-=amount;
    else if(ev.key==="ArrowDown")position.y+=amount;
    else return;
    position.x=clamp(position.x,-scene.clientWidth*.55,scene.clientWidth*.55);
    position.y=clamp(position.y,-scene.clientHeight*.55,scene.clientHeight*.55);
    applyPosition();ev.preventDefault();
  });
  function roundedRect(ctx,x,y,w,h,r){
    ctx.beginPath();ctx.roundRect(x,y,w,h,r);
  }
  function bgCover(ctx,img,w,h){
    var s=Math.max(w/img.naturalWidth,h/img.naturalHeight);
    var sw=w/s,sh=h/s;
    ctx.save();
    ctx.filter="brightness(88%) saturate(98%)";
    ctx.drawImage(img,(img.naturalWidth-sw)/2,(img.naturalHeight-sh)/2,sw,sh,0,0,w,h);
    ctx.restore();
    var shade=ctx.createLinearGradient(0,0,0,h);
    shade.addColorStop(0,"rgba(0,0,0,.04)");
    shade.addColorStop(1,"rgba(0,0,0,.13)");
    ctx.fillStyle=shade;ctx.fillRect(0,0,w,h);
  }
  async function savePreview(){
    if(!photo){message("Bitte zuerst ein eigenes Foto hochladen.");return;}
    saveBtn.disabled=true;message("Vorschau wird erstellt …");
    try{
      if(document.fonts&&document.fonts.ready)await document.fonts.ready;
      var factor=Math.min(2,1600/Math.max(scene.clientWidth,1));
      var width=Math.max(1,Math.round(scene.clientWidth*factor));
      var height=Math.max(1,Math.round(scene.clientHeight*factor));
      var canvas=document.createElement("canvas");canvas.width=width;canvas.height=height;
      var ctx=canvas.getContext("2d");
      if(!ctx)throw new Error("Canvas nicht verfügbar");
      bgCover(ctx,photo,width,height);
      ctx.save();
      ctx.translate((stage.offsetLeft+stage.offsetWidth/2+position.x)*factor,(stage.offsetTop+stage.offsetHeight/2+position.y)*factor);
      ctx.rotate(position.rotation*Math.PI/180);
      ctx.scale(factor*position.zoom,factor*position.zoom);
      var board=document.getElementById("board"),boardClass=board&&board.className||"";
      if(board&&board.offsetWidth&&!boardClass.includes("none")&&!boardClass.includes("contour")){
        var bw=board.offsetWidth,bh=board.offsetHeight;
        ctx.save();
        ctx.shadowColor="rgba(0,0,0,.5)";ctx.shadowBlur=14;ctx.shadowOffsetY=8;
        ctx.fillStyle=getComputedStyle(board).backgroundColor||"rgba(245,245,245,.10)";
        roundedRect(ctx,-bw/2,-bh/2,bw,bh,5);ctx.fill();
        ctx.restore();
      }
      var logo=document.getElementById("logoPreview");
      var logoWrap=document.getElementById("logoPreviewWrap");
      if(logo&&logoWrap&&getComputedStyle(logoWrap).display!=="none"&&logo.complete&&logo.naturalWidth){
        ctx.save();
        var lw=logoWrap.offsetWidth,lh=logoWrap.offsetHeight;
        if(logoWrap.classList.contains("neon-logo")){
          ctx.shadowColor=getComputedStyle(document.documentElement).getPropertyValue("--glow").trim()||"#ffb45c";
          ctx.shadowBlur=20;
        }
        ctx.globalAlpha=parseFloat(getComputedStyle(logoWrap).opacity)||1;
        ctx.drawImage(logo,-lw/2,-lh/2,lw,lh);
        ctx.restore();
      }else{
        var root=document.documentElement,rs=getComputedStyle(root);
        var glow=rs.getPropertyValue("--glow").trim()||"#ffb45c";
        var core=rs.getPropertyValue("--core").trim()||"#fff3df";
        var neon=document.getElementById("neonText"),lines=Array.from(neon.querySelectorAll(".neon-line"));
        var brightness=parseFloat(getComputedStyle(neon).opacity)||.92;
        ctx.globalAlpha=brightness;
        lines.forEach(function(el){
          var style=getComputedStyle(el);
          var size=parseFloat(style.fontSize)||50;
          var y=neon.offsetTop+el.offsetTop+el.offsetHeight/2-stage.offsetHeight/2;
          var txt=el.querySelector(".tube-body")||el;
          var content=(txt.textContent||"").trim();
          if(!content)return;
          ctx.save();
          ctx.font="400 "+size+"px "+style.fontFamily;
          ctx.textAlign="center";ctx.textBaseline="middle";
          var neonClass=neon.className;
          var ink=core,light=glow;
          if(/rgbtext|multitext/.test(neonClass)){
            var gradient=ctx.createLinearGradient(-el.offsetWidth/2,0,el.offsetWidth/2,0);
            gradient.addColorStop(0,"#ff3d7f");gradient.addColorStop(.5,"#38a6ff");gradient.addColorStop(1,"#ffd13c");
            ink=gradient;light="#b86cff";
          }
          if(board&&boardClass.includes("contour")){
            ctx.lineWidth=9;ctx.lineJoin="round";ctx.strokeStyle="rgba(220,223,227,.26)";
            ctx.shadowColor="rgba(0,0,0,.3)";ctx.shadowBlur=7;ctx.strokeText(content,0,y);
          }
          ctx.shadowColor=light;ctx.shadowBlur=27;ctx.fillStyle=light;ctx.fillText(content,0,y);
          ctx.shadowBlur=12;ctx.fillText(content,0,y);
          ctx.shadowBlur=3;ctx.fillStyle=ink;ctx.fillText(content,0,y);
          ctx.restore();
        });
        ctx.globalAlpha=1;
      }
      ctx.restore();
      ctx.save();
      ctx.fillStyle="rgba(0,0,0,.50)";ctx.fillRect(0,height-24*factor,width,24*factor);
      ctx.fillStyle="#f5ede3";ctx.textAlign="center";ctx.font=(10*factor)+"px Arial, sans-serif";
      ctx.fillText("NEONLIGHT.CH  ·  Unverbindliche Raumvorschau – kein exakter Massstab",width/2,height-8*factor);
      ctx.restore();
      var blob=await new Promise(function(resolve){canvas.toBlob(resolve,"image/png");});
      if(!blob)throw new Error("Export nicht möglich");
      var url=URL.createObjectURL(blob),a=document.createElement("a");
      a.href=url;a.download="neonlight-meine-vorschau.png";
      document.body.appendChild(a);a.click();a.remove();
      setTimeout(function(){URL.revokeObjectURL(url);},30000);
      message("Vorschau gespeichert. Die tatsächliche Breite wird separat gewählt.");
    }catch(err){
      message("Speichern leider nicht möglich. Bitte Screenshot der Vorschau erstellen.");
    }finally{saveBtn.disabled=false;}
  }
  saveBtn.addEventListener("click",savePreview);
  window.addEventListener("beforeunload",function(){if(photoUrl)URL.revokeObjectURL(photoUrl);});
  if(badge){
    var updating=false;
    var observer=new MutationObserver(function(){if(updating||!active())return;updating=true;updateBadge();updating=false;});
    observer.observe(badge,{childList:true,characterData:true,subtree:true});
  }
  applyPosition();
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",initializePhotoPreview,{once:true});
  }else{
    initializePhotoPreview();
  }
})();
